import { render, staticRenderFns } from "./KedvezmenyBase.vue?vue&type=template&id=2bc19240&"
import script from "./KedvezmenyBase.vue?vue&type=script&lang=js&"
export * from "./KedvezmenyBase.vue?vue&type=script&lang=js&"
import style0 from "./KedvezmenyBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports